import { auth } from './auth';
import { PaymentStatus, PaymentStatusCode } from './enums';

const storage = {};

const flags = {};

const configs = { config: {} };

const callbackStack = [];

const ready = () => {
  return new Promise((rec) => {
    if (window.AlipayJSBridge) {
      rec();
    } else {
      // 如果没有注入则监听注入的事件
      document.addEventListener('AlipayJSBridgeReady', rec, false);
    }
  });
};

const handleCallback = (error, data) => {
  callbackStack.forEach((item, index) => {
    if (error && typeof item.rej === 'function') {
      item.rej(error);
    } else if (typeof item.rec === 'function') {
      item.rec(data);
    }
    delete callbackStack[index];
  });
};

export const openid = ({ state }) => {
  return new Promise((rec, rej) => {
    if (storage.openid && !flags.openidProcess) {
      rec(storage.openid);
      return;
    }
    if (flags.openidProcess) {
      callbackStack.push({
        rec,
        rej
      });
      return;
    }

    flags.openidProcess = true;
    rej('start auth process');
  }).catch(() => {
    return auth({
      appId: configs.config.appId,
      info: false, // todo: 强制设置info为false,垃圾支付宝不支持用户信息
      state
    });
  }).then((data) => {
    handleCallback(null, data);
    flags.openidProcess = false;
    return data;
  }).catch((e) => {
    handleCallback(e, null);
    flags.openidProcess = false;
    return Promise.resolve(e);
  });
};

export const payment = ({ tradeId }) => {
  return ready().then(() => {
    return new Promise((rec) => {
      window.AlipayJSBridge.call('tradePay', {
        tradeNO: tradeId
      }, ({ resultCode }) => {
        rec({
          code: Number(resultCode),
          status: PaymentStatusCode[Number(resultCode)],
          message: PaymentStatus[Number(resultCode)] || `订单支付失败: ${resultCode}`
        });
      });
    });
  });
};

export const getLocation = () => {
  return ready().then(() => {
    return new Promise((rec, rej) => {
      window.AlipayJSBridge.call('getLocation', { requestType: 2 }, (result) => {
        if (result.error) {
          rej(result.error);
        }
        rec({
          longitude: result.longitude,
          latitude: result.latitude
        });
      });
    });
  });
};

export const openLocation = ({ longitude, latitude, name, address }) => {
  return ready().then(() => {
    return new Promise((rec, rej) => {
      window.AlipayJSBridge.call('openLocation', {
        longitude,
        latitude,
        name,
        address,
        scale: 15
      }, (result) => {
        if (result.error) {
          rej(result.error);
        }
        return {
          longitude: result.longitude,
          latitude: result.latitude
        };
      });
    });
  });
};

export const scan = ({ type = 'qr', actionType = 'scan' } = {}) => {
  return ready().then(() => {
    return new Promise((rec, rej) => {
      window.AlipayJSBridge.call('scan', {
        type,
        actionType
      }, (result) => {
        if (result.error) {
          switch (String(result.error)) {
            case '10': {
              rej('用户取消');
              return;
            }
            case '11': {
              rej('操作失败');
              return;
            }
            default: {
              rej('未知错误');
              return;
            }
          }
        }

        if (type === 'bar') {
          rec(result.barCode);
          return;
        }
        rec(result.qrCode);
      });
    });
  });
};

export const getConfig = () => {
  return configs.config;
};

export const config = ({ appId }) => {
  configs.config = { appId };
  return Promise.resolve();
};
